/* globals Parvus jQuery */

;(function ($) {
  // if the link doesn't have a data-caption, use markup from figcaption
  $('.lightbox').each(function (n, ele) {
    if (!ele.hasAttribute('data-caption')) {
      $(ele).attr({
        'data-caption': $(ele).parent('.detail-image').find('figcaption').html()
      })
    }
  })

  const prvs = new Parvus({
    gallerySelector: null,
    docClose: false,
    swipeClose: true
  })
})(jQuery)
